// LIBRARIES
import styled, { keyframes } from "styled-components";

// MISC
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  MARGIN,
  SIZE,
} from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

const fade = keyframes`
  0% {
    opacity: 0;
  }
  12.5%{
    opacity: .25;
  }
  25% {
    opacity: .75;
  }
  37.5% {
    opacity: 1;
  }
  50%{
    opacity: 1;
  }
  62.5%{
    opacity: 1;
  }
  75% {
    opacity: .75;
  }
  87.5%{
    opacity: .25;
  }
  100% {
    opacity: 0;
  }
`;

export const CampaignParagraph = styled.div`
  & p {
    padding-bottom: 1em;
  }
`;
export const BackOnTopWrapper = styled.div`
  height: 64px;
  width: 64px;
  position: fixed;
  border-radius: 100%;
  background-color: ${COLORS.Background};
  bottom: 24px;
  right: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  z-index: 100;
`;
export const BackOnTopImg = styled.img`
  height: 22px;
  width: auto;
  transform: rotate(-90deg);
`;

export const NewsAndPartnersDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const HeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-bottom-left-radius: ${BORDER_RADIUS.radius24};
  border-bottom-right-radius: ${BORDER_RADIUS.radius24};
`;

export const HeaderImageWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  height: 511px;
  margin-top: -85px;
  border-bottom-left-radius: ${BORDER_RADIUS.radius24};
  border-bottom-right-radius: ${BORDER_RADIUS.radius24};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    height: 400px;
  }
`;

export const Body = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${MARGIN.max40};
  padding: 0 ${MARGIN.max80};
  position: sticky;
  gap: 34px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    justify-content: center;
    flex-direction: column;
    padding: 0;
    gap: ${MARGIN.fix24};
    margin: 0 ${MARGIN.fix24};
    margin-top: ${MARGIN.fix24};
  }
`;

export const FirstColumn = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  top: 120px;
  z-index: 1001;
  position: sticky;
  height: 650px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
    top: 0;
    position: relative;
    height: auto;
  }
`;

export const InsideFirstColumn = styled.div`
  position: sticky;
`;

export const SecondColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.fix24};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
    height: auto;
    gap: ${MARGIN.fix16};
  }
`;

export const ThirdColumn = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  position: -webkit-sticky;
  position: sticky;
  top: 120px;
  z-index: 1001;
  height: 776px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
    top: 0;
    position: relative;
    height: auto;
  }
`;

export const InsideThirdColumn = styled.div`
  position: sticky;
`;

export const BackToWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 200px;
  margin-bottom: ${MARGIN.max10};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  opacity: 0.5;
  &:hover {
    opacity: 0.8;
  }
`;

export const BackToImage = styled.img`
  margin-top: 2px;
  margin-right: 8px;
  width: 10px;
  height: 16px;
`;

export const BackToButton = styled.button`
  background-color: transparent;
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const TitleWrapper = styled.div`
  margin-bottom: ${MARGIN.fix24};
`;

export const LeftCard = styled.div`
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: ${MARGIN.fix32};
`;

export const LeftCardTitle = styled.div`
  margin-bottom: ${MARGIN.fix16};
`;

export const CenterCardTitle = styled.div`
  margin-bottom: ${MARGIN.fix24};
`;

export const ContentCard = styled.div`
  width: 100%;
  height: auto;
  padding: ${SIZE.max40};
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius32};
  font-family: ${FONT_FAMILY.poppins};
  font-size: ${FONT_SIZE.max18};
  font-weight: ${FONT_WEIGHT.regular};
`;

export const SocialMediaCard = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  padding: ${MARGIN.fix16} ${MARGIN.fix32};
  background-color: ${COLORS.VividAuburn};
  border-radius: ${BORDER_RADIUS.radius32};
  margin-bottom: ${MARGIN.fix24};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-bottom: ${MARGIN.max12};
  }
`;

export const SocialMediaIcons = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.fix24};
`;

export const SocialMediaIcon = styled.img`
  height: 24px;
  width: auto;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const CopyToClipboardWrapper = styled.button`
  background-color: transparent;
  border: none;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  position: relative;
`;

export const OtherGuidesCard = styled.div`
  width: 100%;
  height: auto;
  padding: ${MARGIN.fix32};
  gap: ${MARGIN.fix24};
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
`;

export const ImgStyled = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: ${BORDER_RADIUS.radius16};
`;

export const OtherChapters = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max12};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const OtherCampaignsContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & > * {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;

export const DateWrapper = styled.div`
  margin-bottom: ${MARGIN.max4};
`;

export const CampaigneNull = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: center;
  justify-content: center;
  padding: ${SIZE.max200} ${SIZE.max84};
`;
export const MessageContainer = styled.div`
  background-color: ${COLORS.Cultured};
  border-radius: ${BORDER_RADIUS.radius32};
  padding: ${SIZE.max65} ${SIZE.max32} ${SIZE.max32} ${SIZE.max32};
  width: 100%;
  max-width: 750px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const ButtonContainer = styled.div`
  margin: ${MARGIN.fix24};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CopyToClipboardTooltip = styled.div`
  width: ${SIZE.max200};
  position: absolute;
  background-color: ${COLORS.Background};
  padding: ${MARGIN.fix16};
  border-radius: ${BORDER_RADIUS.radius16};
  transform: translate(-50%, -50%);
  outline: 2px solid ${COLORS.MetalicSilver}80;
  animation: ${fade} 2s ease-in-out;
`;

export const SkeletonWrapperChapter = styled.div`
  width: 100%;
`;

export const SkeletonWrapperOtherChapter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${MARGIN.max10};
`;

export const ImgLeftCard = styled.img`
  height: 40px;
  width: 40px;
  margin-right: 16px;
`;

export const CenterLeftCard = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapperTexts = styled.div`
  display: flex;
  flex-direction: row;
  gap: 64px;
  @media (max-width: 1600px) {
    gap: 30px;
  }
  @media (max-width: 1300px) {
    gap: 10px;
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    gap: 20px;
  }
`;

export const RedCircle = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${COLORS.VividAuburn};
  border-radius: 50%;
`;

export const ScrollTargetWrapper = styled.div`
  padding-top: ${MARGIN.max120};
  margin-top: -${MARGIN.max120};
  display: block;

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-top: ${MARGIN.max100};
    margin-top: -${MARGIN.max100};
    display: block;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 218px;
`;

export const PartnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`;

export const ImgPartner = styled.img`
  width: 40px;
  height: 40px;
`;

export const TitleLeftCard = styled.div`
  margin-bottom: 24px;
`;

export const ContentLeftCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionsLeftCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DetailsSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ImgLeftSection = styled.img`
  width: 24px;
  height: 24px;
`;

export const DetailsOtherEventsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -8px;
`;
